import React, { useEffect, useState } from 'react'
import { ApproveUserProfile,banUser,denyUserProfile,unbanUser } from '../../../../../../common/_services/admin.service'
import { User, UserPhoto, UserVerifyPhoto } from '../../../../../../common/types/user'
import { useFetch } from '../../../../_core/hooks'
import ProfileBox from '../../_components/profile/profileBox'
import { DataTable, DataTableExpandedRows, DataTableFilterEvent, DataTableFilterMeta, DataTablePageEvent, DataTableValueArray } from 'primereact/datatable'
import { Column,ColumnProps,ColumnFilterElementTemplateOptions } from 'primereact/column'
import { InputText } from 'primereact/inputtext'
import { getUsers, LazyTableState } from '_services/users.service'
import { Image } from 'primereact/image'
import { Button } from 'primereact/button'
import { FilterMatchMode, } from 'primereact/api'
import SidebarWrapper from '../../_components/profile/components/SidebarWrapper'
import { IconField } from 'primereact/iconfield'
import { InputIcon } from 'primereact/inputicon'
import { MultiSelect, MultiSelectChangeEvent } from 'primereact/multiselect'
import { TabPanel, TabView } from 'primereact/tabview'
import PhotoReview from './photoReview'
import VerifyReview from './userVerifyReview'
import VideoInterviewReview from './videoInterviewReview'
import {formatDateTimeAbsolute} from '../../../../../../common/util/formatters'
import * as jt from '@js-joda/core'
import StatusBadges from './components/status-badges'

export type PhotoWithName = (UserPhoto | UserVerifyPhoto & {firstName:string, lastName:string})

interface status {
  display:string,
  severity:"success" | "danger" | "info" | "warning" | null | undefined
}
let filterDebounce: number | null = null

const UserApproval: React.FC = () => {
  const [users, setUser] = useState<User[]>([])
  const [expandedRows, setExpandedRows] = useState<DataTableExpandedRows | DataTableValueArray | undefined>(undefined)
  const [loadingUsers, setLoadingUsers] = useState<boolean>(false)
  const [selectedUsers, setSelectedUsers] = useState<User[]>([])
  const [viewUser, setViewUser] = useState<string>('')
  const [globalFilterValue, setGlobalFilterValue] = useState<string>('')
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [lazyState, setlazyState] = useState<LazyTableState<DataTableFilterMeta>>({
    first             : 0,
    rows              : 10,
    page              : 0,
    filters: {
      globalFilter            : { value: '', matchMode: FilterMatchMode.CONTAINS },
      firstName               : { value: '', matchMode: FilterMatchMode.CONTAINS },
      lastName                : { value: '', matchMode: FilterMatchMode.CONTAINS },
      phone                   : { value: '', matchMode: FilterMatchMode.CONTAINS },
      email                   : { value: '', matchMode: FilterMatchMode.CONTAINS },
      occupationName          : { value: '', matchMode: FilterMatchMode.CONTAINS },
      aboutMe                 : { value: '', matchMode: FilterMatchMode.CONTAINS },
      highestEducationLevel   : { value: '', matchMode: FilterMatchMode.CONTAINS },
      status                  : { value: ['Pending User Review'], matchMode: FilterMatchMode.CUSTOM  },
    }
});

  const [statuses] = useState<status[]>([
    {display:'User Approved', severity: 'success'},
    {display:'Pending User Review', severity: 'danger'},
    {display:'Pending Photo Approval', severity: 'danger'},
    {display:'Photos Approved', severity: 'success'},
    {display:'Verified', severity: 'success'},
    {display:'Pending Verify', severity: 'danger'},
    {display:'Premium', severity: 'info'},
    {display:'Banned', severity: 'danger'},
    {display:'Denied User Approval', severity: 'danger'},
  ])

const FormatDate = (date: string) => {
  const instantProcessed = date ? formatDateTimeAbsolute(jt.Instant.parse(date)) : null
  return instantProcessed;
}

const multiFilterOption = (options: ColumnFilterElementTemplateOptions) => {
  return (
    <MultiSelect
      id="status"
      name="status"
      display="chip"
      value={options.value}
      options={statuses}
      onChange={(e: MultiSelectChangeEvent) => options.filterApplyCallback(e.value)}
      optionLabel="display"
      optionValue="display"
      placeholder="Any"
      className="p-column-filter"
      maxSelectedLabels={1}
      style={{ minWidth: '10rem' }}
    />
  )
}

  const columns: ColumnProps[] = [
    {
      field: '',
      header: 'Profile Photo',

      body: (data: User) =>
        <>
          <Image onClick={() => {setViewUser(data.id)}} src={data.userPhotos && data.userPhotos.length > 0 ? data.userPhotos[0].imgUrl : ''} alt="Image" width="256px" className="shadow-4" />
        </>
    },
      {
        field: 'firstName',
        header: 'First Name',
        filter: true,
        filterPlaceholder: "First Name",
      },
      {
        field: 'lastName',
        header: 'Last Name',
        filter: true,
        filterPlaceholder: "Last Name",
      },
      {
        field: 'phone',
        header: 'Phone #',
        filter: true,
        filterPlaceholder: "Phone #",
        style: { width: '8rem' },
        body:(data: User) => <>{data.countryCode}+ {data.phone}</>
      },
      {
        field: 'email',
        header: 'Email',
        filter: true,
        filterPlaceholder: "Email",
      },
      {
        field: 'occupationName',
        header: 'Occupation',
        filter: true,
        filterPlaceholder: "Occupation search",
        body:(data:User) => <>{data.userMetadata?.occupationName}</>
      },
      {
        field: 'userMetadata.aboutMe',
        header: 'About Me',
        style: { width: '15rem' },
        filter: false,
        filterPlaceholder: "About me search",
      },
      {
        field: 'lastLoggedIn',
        header: 'Last Acvtive',
        filter: true,
        filterPlaceholder: "Last Active Search",
        body: (data: User) => <>{FormatDate(data.lastLoggedIn ?? data.createdDate)}</>
      },
      {
        columnKey: 'status',
        field: 'status',
        header: 'Status',
        filter: true,
        style: { width: '1rem' },

        filterPlaceholder: "Status search",
        filterMatchMode:"custom_status",
        filterElement: multiFilterOption,
        body: (data: User) => <>{<StatusBadges data={data}/>}</>
      },
  ]
  let abortController: AbortController | null = null

  const fetchUsers = async () => {
    setLoadingUsers(true)
    console.log('here', loadingUsers)
    // Cancel the previous request if it's still running
    if (abortController) {
      abortController.abort()
    }

    // Create a new AbortController for the current request
    abortController = new AbortController()
    const signal = abortController.signal

    try {
      setLoadingUsers(true)

      // Fetch the users
      await getUsers<DataTableFilterMeta>(lazyState, (x) => {
        if (!signal.aborted) {
          setUser(x.data.users)
          console.log(x.data.users)
          setTotalRecords(x.data.total)
        }
      })
    } catch (error) {
      if (signal.aborted) {
        console.log('Request canceled')
      } else {
        console.error('Fetch error:', error)
      }
    } finally{
      setLoadingUsers(false)
    }
  }

  const loadUsers = useFetch(
    () => getUsers<DataTableFilterMeta>(lazyState),
    (x) => {
      if (x){
        setUser(x.users)
        setTotalRecords(x.total)
      }
    },
    []
  )

  useEffect(() => {
    fetchUsers()
}, [lazyState])

const onPage = (event: DataTablePageEvent) => {
  setlazyState((prev) => ({...prev,...event}))
}


const onFilter = (event: DataTableFilterEvent) => {
    event['first'] = 0
    event['page'] = 0
    setlazyState((prev => ({...prev,'filters':{...prev.filters,...event.filters}})))
}

const onGlobalFilterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  setGlobalFilterValue(event.target.value)
  if(filterDebounce){
    window.clearTimeout(filterDebounce)
  }
  filterDebounce = window.setTimeout(() => {
  onFilter({filters: {'globalFilter': {value: event.target.value, matchMode: FilterMatchMode.CONTAINS}}})
  }, 1000)
}

  return <div className="m-4 justify-content-center h-100">
      <SidebarWrapper
        position="right"
        className="w-full md:w-40rem lg:w-40rem"
        visible={!!viewUser}
        onHide={() => setViewUser('')}
        style={{width:'45%'}}
      >
       {
          viewUser != '' && <ProfileBox
            userId={viewUser}
          />
        }
      </SidebarWrapper>
      <TabView>
        <TabPanel header="User Approval">
          <>
            <DataTable
              stripedRows
              header={
                <div className="d-flex">
                  <div className="p-2 bd-highlight">
                    <h3>User Review</h3>
                  </div>
                  <div className="ms-auto p-2 bd-highligh">
                    <IconField iconPosition="left">
                        <InputIcon className="pi pi-search" />
                        <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" />
                    </IconField>
                  </div>
                </div>
              }
              lazy
              onPage={onPage}
              loading={loadUsers || loadingUsers}
              onFilter={onFilter}
              first={lazyState.first}
              filters={lazyState.filters}
              totalRecords={totalRecords}
              filterDisplay="menu"
              paginator
              rows={lazyState.rows}
              rowsPerPageOptions={[5, 10, 25, 50]}
              value={users}
              tableStyle={{ minWidth: 'min-content' }}
              expandedRows={expandedRows}
              selection={selectedUsers}
              onSelectionChange={(e) => setSelectedUsers([e.value])}
              onRowToggle={(e) => {setExpandedRows(e.data)}}
              size='small'
            >
              <Column selectionMode="multiple" headerStyle={{ width: '2rem' }}></Column>
              {columns.map((x) => <Column
                key={x.field}
                {...x}
                />
              )}
              <Column field="id"
                style={{ width: '20rem' }}
                header="Action"
                body={(y: User) => <>
                  {y.isBanned && <Button label="Unban" className="btn btn-warning  mx-2" onClick={() => {
                    unbanUser([y.id],fetchUsers)
                  }}/>}
                  {!y.isBanned && <Button label="Ban" className="btn btn-danger  mx-2" onClick={() => {
                    banUser([y.id],fetchUsers)
                  }}/>}
                  {(!y.deniedAt) && <Button label="Deny" className="btn btn-secondary" onClick={() => {
                    denyUserProfile([y.id],fetchUsers)
                  }}/>}
                  {(!y.approvedAt) && <Button label="Approve" className="btn btn-primary mx-2"  onClick={() => {
                    ApproveUserProfile([y.id],fetchUsers)
                  }}/>}
                </>}
              ></Column>
            </DataTable>
          </>
        </TabPanel>
        <TabPanel header="Photo Review">
         <PhotoReview openProfile={(x:string) => setViewUser(x)}/>
        </TabPanel>
        <TabPanel header="User Verify Review">
          <VerifyReview openProfile={(x:string) => setViewUser(x)}/>
        </TabPanel>
        <TabPanel header="Video Interview Review">
          <VideoInterviewReview/>
        </TabPanel>
      </TabView>
   </div>
}

export default UserApproval
